
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 119.5 222"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#5b89c1","d":"M81.4 3.4L75.6 0 0 43.6l.5 175 5.9 3.5z"}}),_c('path',{attrs:{"fill":"#73a6f9","d":"M81.4 3.4l37.7 21.5.3 131.9-113 65.3-.6-175z"}}),_c('path',{attrs:{"fill":"#8dc5fa","d":"M81.4 3.4l37.7 21.5-37.5 21.6z"}}),_c('path',{attrs:{"d":"M103.3 56.2l-82.4 47.5.2 82.5 82.4-47.5-.2-82.5zM26.8 176.7v-12.5l10.9-6.3v12.5l-10.9 6.3zm0-19.1v-12.5l10.9-6.3v12.5l-10.9 6.3zm0-18.6v-12.5l10.9-6.3v12.5L26.8 139zm0-19.6v-12.5l10.9-6.3v12.5l-10.9 6.3zm16.4 47.8l-.1-31.5 38.4-22.2.1 31.5-38.4 22.2zm0-37.9l-.1-31.5 38.4-22.2.1 31.5-38.4 22.2zm44 12.7v-12.5l10.9-6.3v12.5L87.2 142zm0-19v-12.5l10.9-6.3v12.5L87.2 123zm0-18.7V91.8L98 85.6v12.5l-10.8 6.2zm0-19.6V72.2L98 66v12.5l-10.8 6.2z","fill":"#fff"}})])
          )
        }
      }
    